module.exports = __webpack_public_path__ + "img/logo copy.07d1e22e.svg";